import apiRequestService from '@/commonProject/service/apiRequestService';

export default class sharedFileRepository {
    /**
     * 共有ファイル一覧APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async postSharedFileListActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/shrfillst', requestBody, idToken);
        return result;
    }

    /**
     * 共有ファイルダウンロードAPIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async postSharedFileDownloadActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/shrfildld', requestBody, idToken);
        return result;
    }
}
